var items = {
  "block.minecraft.air": "rewve'",
  "block.minecraft.stone": "nagh",
  "block.minecraft.granite": "livri'",
  "block.minecraft.polished_granite": "livri' hab",
  "block.minecraft.diorite": "nagh chis",
  "block.minecraft.polished_diorite": "habbogh nagh chis",
  "block.minecraft.andesite": "yuwey nagh",
  "block.minecraft.polished_andesite": "yuwey nagh hab",
  "block.minecraft.grass_block": "magh buq'ir",
  "block.minecraft.dirt": "lam",
  "block.minecraft.coarse_dirt": "lam ghegh",
  "block.minecraft.podzol": "ngem bir lam",
  "block.minecraft.crimson_nylium": "nether magh doq",
  "block.minecraft.warped_nylium": "nether magh sud",
  "block.minecraft.cobblestone": "nagh tlher",
  "block.minecraft.oak_planks": "'oq sor 'echletmey",
  "block.minecraft.spruce_planks": "seprus sor 'echletmey",
  "block.minecraft.birch_planks": "berich sor 'echletmey",
  "block.minecraft.jungle_planks": "ngem yiq sor 'echletmey",
  "block.minecraft.acacia_planks": "'aqey'sa sor 'echletmey",
  "block.minecraft.dark_oak_planks": "'oq hurgh sor 'echletmey",
  "block.minecraft.crimson_planks": "ghe’tor sor doq 'echlet",
  "block.minecraft.warped_planks": "nether sor sud 'echlet",
  "block.minecraft.oak_sapling": "'oq sor lav",
  "block.minecraft.spruce_sapling": "seprus sor lav",
  "block.minecraft.birch_sapling": "berich sor lav",
  "block.minecraft.jungle_sapling": "ngem yiq sor lav",
  "block.minecraft.acacia_sapling": "'aqey'sa sor lav",
  "block.minecraft.dark_oak_sapling": "'oq hurgh sor lav",
  "block.minecraft.bedrock": "ghorbe'bogh nagh",
  "block.minecraft.sand": "do'ol",
  "block.minecraft.red_sand": "do'ol doq",
  "block.minecraft.gravel": "naghhommey",
  "block.minecraft.gold_ore": "nagh qol'om",
  "block.minecraft.iron_ore": "nagh ‘usqan",
  "block.minecraft.coal_ore": "nagh ghav nin",
  "block.minecraft.nether_gold_ore": "nether nagh qol'om",
  "block.minecraft.oak_log": "'oq sor qechjem'a'",
  "block.minecraft.spruce_log": "seprus sor qechjem'a'",
  "block.minecraft.birch_log": "berich sor qechjem'a'",
  "block.minecraft.jungle_log": "ngem yiq sor qechjem'a'",
  "block.minecraft.acacia_log": "'aqey'sa sor qechjem'a'",
  "block.minecraft.dark_oak_log": "'oq hurgh sor qechjem'a'",
  "block.minecraft.crimson_stem": "ghe’tor sor doq qechjem",
  "block.minecraft.warped_stem": "nether sor sud qechjem",
  "block.minecraft.stripped_oak_log": "'oq sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_spruce_log": "seprus sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_birch_log": "berich sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_jungle_log": "ngem yiq sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_acacia_log": "'aqey'sa sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_dark_oak_log": "'oq hurgh sor qechjem'a' surghlu'pu'bogh",
  "block.minecraft.stripped_crimson_stem": "nether sor doq qechjem surghlu'pu'bogh",
  "block.minecraft.stripped_warped_stem": "nether sor sud qechjem surghlu'pu'bogh",
  "block.minecraft.stripped_oak_wood": "'oq sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_spruce_wood": "seprus sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_birch_wood": "berich sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_jungle_wood": "ngem yiq sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_acacia_wood": "'aqey'sa sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_dark_oak_wood": "'oq hurgh sor hap surghlu'pu'bogh",
  "block.minecraft.stripped_crimson_hyphae": "nether sor doq sirghmey surghlu'pu'bogh",
  "block.minecraft.stripped_warped_hyphae": "nether sor sud sirghmey surghlu'pu'bogh",
  "block.minecraft.oak_wood": "'oq sor hap",
  "block.minecraft.spruce_wood": "seprus sor hap",
  "block.minecraft.birch_wood": "berich sor hap",
  "block.minecraft.jungle_wood": "ngem yiq sor hap",
  "block.minecraft.acacia_wood": "'aqey'sa sor hap",
  "block.minecraft.dark_oak_wood": "'oq hurgh sor hap",
  "block.minecraft.crimson_hyphae": "ghe’tor sor doq sirghmey",
  "block.minecraft.warped_hyphae": "nether sor sud sirghmey",
  "block.minecraft.oak_leaves": "'oq sor pormey",
  "block.minecraft.spruce_leaves": "seprus sor pormey",
  "block.minecraft.birch_leaves": "berich sor pormey",
  "block.minecraft.jungle_leaves": "ngem yiq sor pormey",
  "block.minecraft.acacia_leaves": "'aqey'sa sor pormey",
  "block.minecraft.dark_oak_leaves": "'oq hurgh sor pormey",
  "block.minecraft.sponge": "biq bumwi'",
  "block.minecraft.wet_sponge": "biq bumwi' yiq",
  "block.minecraft.glass": "'al'on",
  "block.minecraft.lapis_ore": "nagh tlhil sud",
  "block.minecraft.lapis_block": "tlhil sud buq'ir",
  "block.minecraft.dispenser": "bahjan",
  "block.minecraft.sandstone": "do'ol nagh",
  "block.minecraft.chiseled_sandstone": "do'ol nagh quhlu'bogh",
  "block.minecraft.cut_sandstone": "do'ol nagh pe'lu'bogh",
  "block.minecraft.note_block": "qoq buq'ir",
  "block.minecraft.powered_rail": "hosbogh tihmey",
  "block.minecraft.detector_rail": "noch tihmey",
  "block.minecraft.sticky_piston": "ngusdi' hum",
  "block.minecraft.cobweb": "sirgh sir'o'",
  "block.minecraft.grass": "magh",
  "block.minecraft.fern": "sanmir san'emder",
  "block.minecraft.dead_bush": "heghbogh lav",
  "block.minecraft.seagrass": "biq'a' magh",
  "block.minecraft.sea_pickle": "biq'a' hurgh",
  "block.minecraft.piston": "ngusdi'",
  "block.minecraft.white_wool": "ved chis",
  "block.minecraft.orange_wool": "doqbogh ‘ej wovbogh ved",
  "block.minecraft.magenta_wool": "doqqu'bogh 'ej sudbogh ved",
  "block.minecraft.light_blue_wool": "sudbogh 'ej wovbogh ved",
  "block.minecraft.yellow_wool": "sudbogh ‘ej wovbogh ved",
  "block.minecraft.lime_wool": "sudqu’bogh ‘ej wovbogh ved",
  "block.minecraft.pink_wool": "doqqu'bogh 'ej wovbogh ved",
  "block.minecraft.gray_wool": "qijbogh 'ej wovbogh ved",
  "block.minecraft.light_gray_wool": "qijbogh 'ej wovqu'bogh ved",
  "block.minecraft.cyan_wool": "sudbogh ’ej wovqu’bogh ved",
  "block.minecraft.purple_wool": "doqbogh 'ej sudbogh ved",
  "block.minecraft.blue_wool": "sudbogh ‘ej hurghbogh ved",
  "block.minecraft.brown_wool": "doqbogh 'ej wovbe'bogh ved",
  "block.minecraft.green_wool": "ved sudqu’",
  "block.minecraft.red_wool": "ved doqqu'",
  "block.minecraft.black_wool": "ved qij",
  "block.minecraft.dandelion": "dande'layan 'insong",
  "block.minecraft.poppy": "pa'piy 'insong",
  "block.minecraft.blue_orchid": "'orqid sud 'insong",
  "block.minecraft.allium": "'anyan o'qqar 'insong",
  "block.minecraft.azure_bluet": "bilu'et sud 'insong",
  "block.minecraft.red_tulip": "tulip 'insong doqqu'",
  "block.minecraft.orange_tulip": "doqbogh ‘ej wovbogh tulip 'insong",
  "block.minecraft.white_tulip": "tulip 'insong chis",
  "block.minecraft.pink_tulip": "doqqu’bogh ‘ej wovbogh tulip 'insong",
  "block.minecraft.oxeye_daisy": "tangqa' min deysiy 'insong",
  "block.minecraft.cornflower": "meyis tir 'insong",
  "block.minecraft.lily_of_the_valley": "ngech li'liy",
  "block.minecraft.wither_rose": "wither ro'sa'",
  "block.minecraft.brown_mushroom": "doqbogh ‘ej wovbe’bogh tera' yav 'atlhqam",
  "block.minecraft.red_mushroom": "tera' yav atlhqam doq",
  "block.minecraft.crimson_fungus": "'atlhqam doq",
  "block.minecraft.warped_fungus": "'atlhqam sud",
  "block.minecraft.crimson_roots": "'oqqar doq",
  "block.minecraft.warped_roots": "'oqqar sud",
  "block.minecraft.nether_sprouts": "nether ghubmey",
  "block.minecraft.weeping_vines": "tlhegh ti saqbogh",
  "block.minecraft.twisting_vines": "tlhegh ti ver",
  "block.minecraft.sugar_cane": "siyech",
  "block.minecraft.kelp": "monqiv",
  "block.minecraft.bamboo": "bambu'",
  "block.minecraft.gold_block": "qol'om buq'ir",
  "block.minecraft.iron_block": "'usqan buq'ir",
  "block.minecraft.oak_slab": "'oq sor buq'ir bid",
  "block.minecraft.spruce_slab": "seprus sor buq'ir bid",
  "block.minecraft.birch_slab": "berich sor buq'ir bid",
  "block.minecraft.jungle_slab": "ngem yiq sor buq'ir bid",
  "block.minecraft.acacia_slab": "'aqey'sa sor buq'ir bid",
  "block.minecraft.dark_oak_slab": "'oq hurgh sor buq'ir bid",
  "block.minecraft.crimson_slab": "nether sor doq bid ngogh",
  "block.minecraft.warped_slab": "nether sor sud buq'ir bid",
  "block.minecraft.stone_slab": "nagh buq'ir bid",
  "block.minecraft.smooth_stone_slab": "nagh hab buq'ir bid",
  "block.minecraft.sandstone_slab": "do'ol nagh buq'ir bid",
  "block.minecraft.cut_sandstone_slab": "do'ol nagh pe'lu'bogh buq'ir bid",
  "block.minecraft.petrified_oak_slab": "'oq sor buq'ir bid 'an",
  "block.minecraft.cobblestone_slab": "nagh tlher buq'ir bid",
  "block.minecraft.brick_slab": "ngoghmey buq'ir bid",
  "block.minecraft.stone_brick_slab": "nagh ngoghmey buq'ir bid",
  "block.minecraft.nether_brick_slab": "nether ngogh buq'ir bid",
  "block.minecraft.quartz_slab": "chosom buq'ir bid",
  "block.minecraft.red_sandstone_slab": "do'ol nagh doq buq'ir bid",
  "block.minecraft.cut_red_sandstone_slab": "do'ol nagh doq pe'lu'bogh buq'ir bid",
  "block.minecraft.purpur_slab": "purpur buq'ir bid",
  "block.minecraft.prismarine_slab": "prismarine buq'ir bid",
  "block.minecraft.prismarine_brick_slab": "prismarine ngoghmey buq'ir bid",
  "block.minecraft.dark_prismarine_slab": "prismarine hurgh buq'ir bid",
  "block.minecraft.smooth_quartz": "chosom hab buq'ir",
  "block.minecraft.smooth_red_sandstone": "habbogh do'ol nagh doq",
  "block.minecraft.smooth_sandstone": "do'ol nagh hab",
  "block.minecraft.smooth_stone": "nagh hab",
  "block.minecraft.bricks": "ngoghmey",
  "block.minecraft.tnt": "jorwi'",
  "block.minecraft.bookshelf": "paq bey'",
  "block.minecraft.mossy_cobblestone": "‘ayivlas ghajbogh nagh ghorlu'bogh",
  "block.minecraft.obsidian": "'al'on nagh",
  "block.minecraft.torch": "sech",
  "block.minecraft.end_rod": "end naq",
  "block.minecraft.chorus_plant": "bomwi' ghom san'emder",
  "block.minecraft.chorus_flower": "bomwi' ghom 'insong",
  "block.minecraft.purpur_block": "nagh sud buq'ir",
  "block.minecraft.purpur_pillar": "purpur tut",
  "block.minecraft.purpur_stairs": "purpur letlh",
  "block.minecraft.spawner": "boghmohwi'",
  "block.minecraft.oak_stairs": "'oq sor letlh",
  "block.minecraft.chest": "derliq",
  "block.minecraft.diamond_ore": "nagh ghav qut",
  "block.minecraft.diamond_block": "ghav qut buq'ir",
  "block.minecraft.crafting_table": "vummeh ras",
  "block.minecraft.farmland": "du' puh",
  "block.minecraft.furnace": "vincha'",
  "block.minecraft.ladder": "tosmeh he",
  "block.minecraft.rail": "tlhil he",
  "block.minecraft.cobblestone_stairs": "nagh tlher letlh",
  "block.minecraft.lever": "chu'meh naq",
  "block.minecraft.stone_pressure_plate": "nagh surmen 'echlet",
  "block.minecraft.oak_pressure_plate": "'oq sor surmen 'echlet",
  "block.minecraft.spruce_pressure_plate": "seprus sor surmen 'echlet",
  "block.minecraft.birch_pressure_plate": "berich sor surmen 'echlet",
  "block.minecraft.jungle_pressure_plate": "ngem yiq sor surmen 'echlet",
  "block.minecraft.acacia_pressure_plate": "'aqey'sa sor surmen 'echlet",
  "block.minecraft.dark_oak_pressure_plate": "'oq hurgh sor surmen 'echlet",
  "block.minecraft.crimson_pressure_plate": "ghe’tor sor doq surmen 'echlet",
  "block.minecraft.warped_pressure_plate": "nether sor sud surmen 'echlet",
  "block.minecraft.polished_blackstone_pressure_plate": "habbogh nagh qij jembogh 'echlet",
  "block.minecraft.redstone_ore": "nagh redstone",
  "block.minecraft.redstone_torch": "redstone sech",
  "block.minecraft.snow": "chal chuch",
  "block.minecraft.ice": "chuch",
  "block.minecraft.snow_block": "chal chuch buq'ir",
  "block.minecraft.cactus": "qaqtas san'emder",
  "block.minecraft.clay": "dabqi'",
  "block.minecraft.jukebox": "bom jengva' chu'wi'",
  "block.minecraft.oak_fence": "'oq sor tlhoy'hom",
  "block.minecraft.spruce_fence": "seprus sor tlhoy'hom",
  "block.minecraft.birch_fence": "berich sor thloy'hom",
  "block.minecraft.jungle_fence": "ngem yiq sor tlhoy'hom",
  "block.minecraft.acacia_fence": "'aqey'sa sor tlhoy'hom",
  "block.minecraft.dark_oak_fence": "'oq hurgh sor tlhoy'hom",
  "block.minecraft.crimson_fence": "ghe’tor sor doq tlhoy'hom",
  "block.minecraft.warped_fence": "nether sor sud tlhoy'hom",
  "block.minecraft.pumpkin": "'aquta' nah",
  "block.minecraft.carved_pumpkin": "'aquta' nah pe'lu'ta'bogh",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "qa' do'ol",
  "block.minecraft.soul_soil": "qa' lam",
  "block.minecraft.basalt": "hotnagh",
  "block.minecraft.polished_basalt": "hotnagh hab",
  "block.minecraft.soul_torch": "qa' sech",
  "block.minecraft.glowstone": "wovbogh nagh",
  "block.minecraft.jack_o_lantern": "wewbogh 'aquta' nah quhlu'pu'bogh",
  "block.minecraft.oak_trapdoor": "'oq sor vonmeh lojmit",
  "block.minecraft.spruce_trapdoor": "seprus sor vonmeh lojmit",
  "block.minecraft.birch_trapdoor": "berich sor vonmeh lojmit",
  "block.minecraft.jungle_trapdoor": "ngem yiq sor vonmeh lojmit",
  "block.minecraft.acacia_trapdoor": "'aqey'sa sor vonmeh lojmit",
  "block.minecraft.dark_oak_trapdoor": "'oq hurgh sor vonmeh lojmit",
  "block.minecraft.crimson_trapdoor": "ghe’tor sor doq vonmeh lojmit",
  "block.minecraft.warped_trapdoor": "nether sor sud vonmeh lojmit",
  "block.minecraft.infested_stone": "nagh ngejlu'bogh",
  "block.minecraft.infested_cobblestone": "nagh tlher ngejlu'bogh",
  "block.minecraft.infested_stone_bricks": "nagh ngoghmey ngejlu'bogh",
  "block.minecraft.infested_mossy_stone_bricks": "‘ayivlas nagh ngoghmey ngejlu'bogh",
  "block.minecraft.infested_cracked_stone_bricks": "nagh ngoghmey qihlu'bogh 'ej ngejlu'bogh",
  "block.minecraft.infested_chiseled_stone_bricks": "nagh ngoghmey quhlu'bogh 'ej ngejlu'bogh",
  "block.minecraft.stone_bricks": "nagh ngoghmey",
  "block.minecraft.mossy_stone_bricks": "‘ayivlas nagh ngoghmey",
  "block.minecraft.cracked_stone_bricks": "nagh ngoghmey qihlu'bogh",
  "block.minecraft.chiseled_stone_bricks": "nagh ngoghmey quhlu'bogh",
  "block.minecraft.brown_mushroom_block": "doqbogh ‘ej wovbe’bogh tera' yav 'atlhqam ngogh",
  "block.minecraft.red_mushroom_block": "tera' yav atlhqam doq ngogh",
  "block.minecraft.mushroom_stem": "tera' yav 'atlhqam qechjem",
  "block.minecraft.iron_bars": "'usqan naqmey",
  "block.minecraft.chain": "mir",
  "block.minecraft.glass_pane": "'al'on 'echlet",
  "block.minecraft.melon": "qaq nah",
  "block.minecraft.vine": "tlhegh ti",
  "block.minecraft.oak_fence_gate": "'oq sor tlhoy'hom lojmit",
  "block.minecraft.spruce_fence_gate": "seprus sor tlhoy'hom lojmit",
  "block.minecraft.birch_fence_gate": "berich sor tlhoy'hom lojmit",
  "block.minecraft.jungle_fence_gate": "ngem yiq sor tlhoy'hom lojmit",
  "block.minecraft.acacia_fence_gate": "'aqey'sa sor tlhoy'hom lojmit",
  "block.minecraft.dark_oak_fence_gate": "'oq hurgh sor tlhoy'hom lojmit",
  "block.minecraft.crimson_fence_gate": "ghe’tor sor doq tlhoy'hom lojmit",
  "block.minecraft.warped_fence_gate": "nether sor sud tlhoy'hom lojmit",
  "block.minecraft.brick_stairs": "ngogh letlh",
  "block.minecraft.stone_brick_stairs": "nagh ngogh letlh",
  "block.minecraft.mycelium": "'atlhqam sirghmey",
  "block.minecraft.lily_pad": "'echlet por'a'",
  "block.minecraft.nether_bricks": "nether ngoghmey",
  "block.minecraft.cracked_nether_bricks": "nether ngogh qihlu'bogh",
  "block.minecraft.chiseled_nether_bricks": "nether ngogh quhlu'bogh",
  "block.minecraft.nether_brick_fence": "nether ngogh tlhoy'hom",
  "block.minecraft.nether_brick_stairs": "nether ngogh letlh",
  "block.minecraft.enchanting_table": "resmeh ras",
  "block.minecraft.end_portal_frame": "end lojmit qal'aq",
  "block.minecraft.end_stone": "end nagh",
  "block.minecraft.end_stone_bricks": "end nagh ngoghmey",
  "block.minecraft.dragon_egg": "lung'a' qim",
  "block.minecraft.redstone_lamp": "redstone wovmohwi'",
  "block.minecraft.sandstone_stairs": "do'ol nagh letlh",
  "block.minecraft.emerald_ore": "nagh patmor",
  "block.minecraft.ender_chest": "ender derliq",
  "block.minecraft.tripwire_hook": "tangmohmeh sirgh siril",
  "block.minecraft.emerald_block": "patmor ngogh",
  "block.minecraft.spruce_stairs": "seprus sor letlh",
  "block.minecraft.birch_stairs": "berich sor letlh",
  "block.minecraft.jungle_stairs": "ngem yiq sor letlh",
  "block.minecraft.crimson_stairs": "ghe’tor sor doq letlh",
  "block.minecraft.warped_stairs": "nether sor sud letlh",
  "block.minecraft.command_block": "ra'wi' buq'ir",
  "block.minecraft.beacon": "ri'meh wovmohwi'",
  "block.minecraft.cobblestone_wall": "nagh tlher tlhoy'",
  "block.minecraft.mossy_cobblestone_wall": "pochmo' buy'bogh nagh red",
  "block.minecraft.brick_wall": "ngoghmey tlhoy'",
  "block.minecraft.prismarine_wall": "prismarine tlhoy'",
  "block.minecraft.red_sandstone_wall": "do'ol nagh doq tlhoy'",
  "block.minecraft.mossy_stone_brick_wall": "‘ayivlas nagh ngoghmey tlhoy‘",
  "block.minecraft.granite_wall": "livri' tlhoy'",
  "block.minecraft.stone_brick_wall": "nagh ngoghmey tlhoy'",
  "block.minecraft.nether_brick_wall": "nether ngogh tlhoy'",
  "block.minecraft.andesite_wall": "yuwey nagh tlhoy'",
  "block.minecraft.red_nether_brick_wall": "nether ngogh doq tlhoy'",
  "block.minecraft.sandstone_wall": "do'ol nagh tlhoy'",
  "block.minecraft.end_stone_brick_wall": "end nagh ngoghmey tlhoy'",
  "block.minecraft.diorite_wall": "nagh chis tlhoy'",
  "block.minecraft.blackstone_wall": "nagh qij tlhoy'",
  "block.minecraft.polished_blackstone_wall": "habbogh nagh qij tlhoy'",
  "block.minecraft.polished_blackstone_brick_wall": "habbogh nagh qij ngoghmey tlhoy'",
  "block.minecraft.stone_button": "nagh leq",
  "block.minecraft.oak_button": "'oq sor leq",
  "block.minecraft.spruce_button": "seprus sor leq",
  "block.minecraft.birch_button": "berich sor leq",
  "block.minecraft.jungle_button": "ngem yiq sor leq",
  "block.minecraft.acacia_button": "'aqey'sa sor leq",
  "block.minecraft.dark_oak_button": "'oq hurgh sor leq",
  "block.minecraft.crimson_button": "ghe’tor sor doq leq",
  "block.minecraft.warped_button": "nether sor sud leq",
  "block.minecraft.polished_blackstone_button": "habbogh nagh qij leq",
  "block.minecraft.anvil": "mitlhmeh jan",
  "block.minecraft.chipped_anvil": "mitlhmeh jan qihlu'pu'bogh",
  "block.minecraft.damaged_anvil": "mitlhmeh jan qihqu'lu'pu'bogh",
  "block.minecraft.trapped_chest": "vonwi' derliq",
  "block.minecraft.light_weighted_pressure_plate": "surmen 'echlet tis",
  "block.minecraft.heavy_weighted_pressure_plate": "surmen 'echlet 'ugh",
  "block.minecraft.daylight_detector": "pem noch",
  "block.minecraft.redstone_block": "redstone buq'ir",
  "block.minecraft.nether_quartz_ore": "nether nagh chosom",
  "block.minecraft.hopper": "tomter",
  "block.minecraft.chiseled_quartz_block": "chosom quhlu'bogh buq'ir",
  "block.minecraft.quartz_block": "chosom buq'ir",
  "block.minecraft.quartz_bricks": "chosom ngoghmey",
  "block.minecraft.quartz_pillar": "chosom tut",
  "block.minecraft.quartz_stairs": "chosom letlh",
  "block.minecraft.activator_rail": "chu'wi' tihmey",
  "block.minecraft.dropper": "chaghwi'",
  "block.minecraft.white_terracotta": "chisbogh dabqi' let",
  "block.minecraft.orange_terracotta": "doqbogh ‘ej wovbogh dabqi' let",
  "block.minecraft.magenta_terracotta": "doqqu'bogh 'ej sudbogh dabqi' let",
  "block.minecraft.light_blue_terracotta": "sudbogh ‘ej wovbogh dabqi' let",
  "block.minecraft.yellow_terracotta": "sudbogh ‘ej wovbogh dabqi' let",
  "block.minecraft.lime_terracotta": "sudqu’bogh ‘ej wovbogh dabqi' let",
  "block.minecraft.pink_terracotta": "doqqu’bogh ‘ej wovbogh dabqi' let",
  "block.minecraft.gray_terracotta": "qijbogh 'ej wovbogh dabqi' let",
  "block.minecraft.light_gray_terracotta": "qijbogh ‘ej wovqu’bogh dabqi' let",
  "block.minecraft.cyan_terracotta": "sudbogh ’ej wovqu’bogh dabqi' let",
  "block.minecraft.purple_terracotta": "doqbogh 'ej sudbogh dabqi' let",
  "block.minecraft.blue_terracotta": "sudbogh ‘ej hurghbogh dabqi' let",
  "block.minecraft.brown_terracotta": "doqbogh ‘ej wovbe’bogh dabqi' let",
  "block.minecraft.green_terracotta": "sudqu’bogh dabqi' let",
  "block.minecraft.red_terracotta": "doqqu'bogh dabqi' let",
  "block.minecraft.black_terracotta": "qijbogh dabqi' let",
  "block.minecraft.barrier": "botwi' buq'ir",
  "block.minecraft.iron_trapdoor": "'usqan vonmeh lojmit",
  "block.minecraft.hay_block": "sargh soj buq'ir",
  "block.minecraft.white_carpet": "tlhim chis",
  "block.minecraft.orange_carpet": "doqbogh ‘ej wovbogh tlhim",
  "block.minecraft.magenta_carpet": "doqqu’bogh ‘ej sudbogh tlhim",
  "block.minecraft.light_blue_carpet": "sudbogh ‘ej wovbogh tlhim",
  "block.minecraft.yellow_carpet": "sudbogh ‘ej wovbogh tlhim",
  "block.minecraft.lime_carpet": "sudqu’bogh ‘ej wovbogh tlhim",
  "block.minecraft.pink_carpet": "doqqu’bogh ‘ej wovbogh tlhim",
  "block.minecraft.gray_carpet": "qijbogh 'ej wovbogh tlhim",
  "block.minecraft.light_gray_carpet": "qijbogh ‘ej wovqu’bogh tlhim",
  "block.minecraft.cyan_carpet": "sudbogh ’ej wovqu’bogh tlhim",
  "block.minecraft.purple_carpet": "doqbogh 'ej sudbogh tlhim",
  "block.minecraft.blue_carpet": "sudbogh ‘ej hurghbogh tlhim",
  "block.minecraft.brown_carpet": "doqbogh ‘ej wovbe’bogh tlhim",
  "block.minecraft.green_carpet": "tlhim sudqu’",
  "block.minecraft.red_carpet": "tlhim doqqu'",
  "block.minecraft.black_carpet": "tlhim qij",
  "block.minecraft.terracotta": "dabqi' let",
  "block.minecraft.coal_block": "ghav nin buq'ir",
  "block.minecraft.packed_ice": "chuch his",
  "block.minecraft.acacia_stairs": "'aqey'sa sor letlh",
  "block.minecraft.dark_oak_stairs": "'oq hurgh sor letlh",
  "block.minecraft.slime_block": "huh buq'ir",
  "block.minecraft.grass_path": "magh taw",
  "block.minecraft.sunflower": "jul 'insong",
  "block.minecraft.lilac": "laylaq 'insong",
  "block.minecraft.rose_bush": "ro'sa' lav",
  "block.minecraft.peony": "piy'aniy 'insong",
  "block.minecraft.tall_grass": "magh woch",
  "block.minecraft.large_fern": "sanmir san'emder tin",
  "block.minecraft.white_stained_glass": "'al'on chis",
  "block.minecraft.orange_stained_glass": "'al'on doq 'ej beqpuj rur",
  "block.minecraft.magenta_stained_glass": "doqqu'bogh 'ej sudbogh 'al'on",
  "block.minecraft.light_blue_stained_glass": "'al'on sud 'ej wov",
  "block.minecraft.yellow_stained_glass": "'al'on sud 'ej wovqu'",
  "block.minecraft.lime_stained_glass": "'al'on sudqu' 'ej wov",
  "block.minecraft.pink_stained_glass": "'al'on doqqu' 'ej wov",
  "block.minecraft.gray_stained_glass": "'al'on qij 'ej wov",
  "block.minecraft.light_gray_stained_glass": "'al'on qij 'ej wovqu'",
  "block.minecraft.cyan_stained_glass": "'al'on sud 'ej wov",
  "block.minecraft.purple_stained_glass": "'al'on doq 'ej sud",
  "block.minecraft.blue_stained_glass": "'al'on sud",
  "block.minecraft.brown_stained_glass": "'al'on doq 'ej hurgh",
  "block.minecraft.green_stained_glass": "'al'on sudqu'",
  "block.minecraft.red_stained_glass": "'al'on doqqu'",
  "block.minecraft.black_stained_glass": "'al'on qij",
  "block.minecraft.white_stained_glass_pane": "'al'on 'echlet chis",
  "block.minecraft.orange_stained_glass_pane": "'al'on 'echlet doq",
  "block.minecraft.magenta_stained_glass_pane": "doqqu'bogh 'ej sudbogh 'al'on vol",
  "block.minecraft.light_blue_stained_glass_pane": "'al'on 'echlet sud 'ej wov",
  "block.minecraft.yellow_stained_glass_pane": "'al'on 'echlet sud 'ej wovqu'",
  "block.minecraft.lime_stained_glass_pane": "'al'on 'echlet sudqu' 'ej qov",
  "block.minecraft.pink_stained_glass_pane": "'al'on 'echlet doqqu' 'ej wov",
  "block.minecraft.gray_stained_glass_pane": "'al'on 'echlet qij 'ej wov",
  "block.minecraft.light_gray_stained_glass_pane": "'al'on 'echlet qij 'ej wovqu'",
  "block.minecraft.cyan_stained_glass_pane": "'al'on 'echlet sud 'ej wov",
  "block.minecraft.purple_stained_glass_pane": "'al'on 'echlet doq 'ej sud",
  "block.minecraft.blue_stained_glass_pane": "'al'on 'echlet sud",
  "block.minecraft.brown_stained_glass_pane": "'al'on 'echlet doq 'ej hurgh",
  "block.minecraft.green_stained_glass_pane": "'al'on 'echlet sudqu'",
  "block.minecraft.red_stained_glass_pane": "'al'on 'echlet doqqu'",
  "block.minecraft.black_stained_glass_pane": "'al'on 'echlet qij",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine ngoghmey",
  "block.minecraft.dark_prismarine": "prismarine hurgh",
  "block.minecraft.prismarine_stairs": "prismarine letlh",
  "block.minecraft.prismarine_brick_stairs": "prismarine ngoghmey letlh",
  "block.minecraft.dark_prismarine_stairs": "prismarine hurgh letlh",
  "block.minecraft.sea_lantern": "biq'a' wovmohwi'",
  "block.minecraft.red_sandstone": "do'ol nagh doq",
  "block.minecraft.chiseled_red_sandstone": "do'ol nagh doq quh'lu'bogh",
  "block.minecraft.cut_red_sandstone": "do'ol nagh doq pe'lu'bogh",
  "block.minecraft.red_sandstone_stairs": "do'ol nagh doq letlh",
  "block.minecraft.repeating_command_block": "ra'qa'bogh ra'wi' buq'ir",
  "block.minecraft.chain_command_block": "mir ra'wi' buq'ir",
  "block.minecraft.magma_block": "vahbo' sub buq'ir",
  "block.minecraft.nether_wart_block": "nether yav 'atlhqam buq'ir",
  "block.minecraft.warped_wart_block": "nether sor sud ti",
  "block.minecraft.red_nether_bricks": "nether ngoghmey ngogh doq",
  "block.minecraft.bone_block": "hom buq'ir",
  "block.minecraft.structure_void": "qach 'achghej",
  "block.minecraft.observer": "bejwi'",
  "block.minecraft.shulker_box": "shulker ngaswi'",
  "block.minecraft.white_shulker_box": "shulker ngaswi' chis",
  "block.minecraft.orange_shulker_box": "doqbogh ‘ej wovbogh shulker ngaswi'",
  "block.minecraft.magenta_shulker_box": "doqqu'bogh 'ej sudbogh shulker ngaswi'",
  "block.minecraft.light_blue_shulker_box": "sudbogh ‘ej wovbogh shulker ngaswi'",
  "block.minecraft.yellow_shulker_box": "sudbogh ‘ej wovbogh shulker ngaswi'",
  "block.minecraft.lime_shulker_box": "sudqu’bogh ‘ej wovbogh shulker ngaswi'",
  "block.minecraft.pink_shulker_box": "doqqu’bogh ‘ej wovbogh shulker ngaswi'",
  "block.minecraft.gray_shulker_box": "qijbogh 'ej wovbogh shulker ngaswi'",
  "block.minecraft.light_gray_shulker_box": "qijbogh ‘ej wovqu’bogh shulker ngaswi'",
  "block.minecraft.cyan_shulker_box": "sudbogh ’ej wovqu’bogh shulker ngaswi'",
  "block.minecraft.purple_shulker_box": "doqbogh 'ej sudbogh shulker ngaswi'",
  "block.minecraft.blue_shulker_box": "sudbogh ‘ej hurghbogh shulker ngaswi'",
  "block.minecraft.brown_shulker_box": "doqbogh ‘ej wovbe’bogh shulker ngaswi'",
  "block.minecraft.green_shulker_box": "shulker ngaswi' sudqu’",
  "block.minecraft.red_shulker_box": "shulker ngaswi' doqqu'",
  "block.minecraft.black_shulker_box": "shulker ngaswi' qij",
  "block.minecraft.white_glazed_terracotta": "chisbogh dabqi' nguv",
  "block.minecraft.orange_glazed_terracotta": "doqbogh ‘ej wovbogh dabqi' nguv",
  "block.minecraft.magenta_glazed_terracotta": "doqqu'bogh 'ej sudbogh dabqi' nguv",
  "block.minecraft.light_blue_glazed_terracotta": "sudbogh ‘ej wovbogh dabqi' nguv",
  "block.minecraft.yellow_glazed_terracotta": "sudbogh ‘ej wovbogh dabqi' nguv",
  "block.minecraft.lime_glazed_terracotta": "sudqu’bogh ‘ej wovbogh dabqi' nguv",
  "block.minecraft.pink_glazed_terracotta": "doqqu’bogh ‘ej wovbogh dabqi' nguv",
  "block.minecraft.gray_glazed_terracotta": "qijbogh 'ej wovbogh dabqi' nguv",
  "block.minecraft.light_gray_glazed_terracotta": "qijbogh ‘ej wovqu’bogh dabqi' nguv",
  "block.minecraft.cyan_glazed_terracotta": "sudbogh ’ej wovqu’bogh dabqi' nguv",
  "block.minecraft.purple_glazed_terracotta": "doqbogh 'ej sudbogh dabqi' nguv",
  "block.minecraft.blue_glazed_terracotta": "sudbogh ‘ej hurghbogh dabqi' nguv",
  "block.minecraft.brown_glazed_terracotta": "doqbogh ‘ej wovbe’bogh dabqi' nguv",
  "block.minecraft.green_glazed_terracotta": "sudqu’bogh dabqi' nguv",
  "block.minecraft.red_glazed_terracotta": "doqqu'bogh dabqi' nguv",
  "block.minecraft.black_glazed_terracotta": "qijbogh dabqi' nguv",
  "block.minecraft.white_concrete": "tungyen chis",
  "block.minecraft.orange_concrete": "doqbogh ‘ej wovbogh tungyen",
  "block.minecraft.magenta_concrete": "doqqu'bogh 'ej sudbogh tungyen",
  "block.minecraft.light_blue_concrete": "sudbogh ‘ej wovbogh tungyen",
  "block.minecraft.yellow_concrete": "sudbogh ‘ej wovbogh tungyen",
  "block.minecraft.lime_concrete": "sudqu’bogh ‘ej wovbogh tungyen",
  "block.minecraft.pink_concrete": "doqqu’bogh ‘ej wovbogh tungyen",
  "block.minecraft.gray_concrete": "qijbogh 'ej wovbogh tungyen",
  "block.minecraft.light_gray_concrete": "qijbogh ‘ej wovqu’bogh tungyen",
  "block.minecraft.cyan_concrete": "sudbogh ’ej wovqu’bogh tungyen",
  "block.minecraft.purple_concrete": "doqbogh 'ej sudbogh tungyen",
  "block.minecraft.blue_concrete": "sudbogh ‘ej hurghbogh tungyen",
  "block.minecraft.brown_concrete": "doqbogh ‘ej wovbe’bogh tungyen",
  "block.minecraft.green_concrete": "tungyen sudqu’",
  "block.minecraft.red_concrete": "tungyen doqqu'",
  "block.minecraft.black_concrete": "tungyen qij",
  "block.minecraft.white_concrete_powder": "tungyen say'qis chis",
  "block.minecraft.orange_concrete_powder": "doqbogh ‘ej wovbogh tungyen say'qis",
  "block.minecraft.magenta_concrete_powder": "doqqu’bogh ‘ej sudbogh tungyen say'qis",
  "block.minecraft.light_blue_concrete_powder": "sudbogh ‘ej wovbogh tungyen say'qis",
  "block.minecraft.yellow_concrete_powder": "sudbogh ‘ej wovbogh tungyen say'qis",
  "block.minecraft.lime_concrete_powder": "sudqu’bogh ‘ej wovbogh tungyen say'qis",
  "block.minecraft.pink_concrete_powder": "doqqu’bogh ‘ej wovbogh tungyen say'qis",
  "block.minecraft.gray_concrete_powder": "qijbogh 'ej wovbogh tungyen say'qis",
  "block.minecraft.light_gray_concrete_powder": "qijbogh ‘ej wovqu’bogh tungyen say'qis",
  "block.minecraft.cyan_concrete_powder": "sudbogh ’ej wovqu’bogh tungyen say'qis",
  "block.minecraft.purple_concrete_powder": "doqbogh 'ej sudbogh tungyen say'qis",
  "block.minecraft.blue_concrete_powder": "sudbogh ‘ej hurghbogh tungyen say'qis",
  "block.minecraft.brown_concrete_powder": "doqbogh ‘ej wovbe’bogh tungyen say'qis",
  "block.minecraft.green_concrete_powder": "tungyen say'qis sudqu’",
  "block.minecraft.red_concrete_powder": "tungyen say'qis doqqu'",
  "block.minecraft.black_concrete_powder": "tungyen say'qis qij",
  "block.minecraft.turtle_egg": "la'siv qim",
  "block.minecraft.dead_tube_coral_block": "heghpu'bogh 'och 'oqe' buq'ir",
  "block.minecraft.dead_brain_coral_block": "heghpu'bogh qoghij 'oqe' buq'ir",
  "block.minecraft.dead_bubble_coral_block": "heghpu'bogh ba'suq 'oqe' buq'ir",
  "block.minecraft.dead_fire_coral_block": "heghpu'bogh qul 'oqe' buq'ir",
  "block.minecraft.dead_horn_coral_block": "heghpu'bogh pu' 'oqe' buq'ir",
  "block.minecraft.tube_coral_block": "'och 'oqe' buq'ir",
  "block.minecraft.brain_coral_block": "qoghij 'oqe' buq'ir",
  "block.minecraft.bubble_coral_block": "ba'suq 'oqe' buq'ir",
  "block.minecraft.fire_coral_block": "qul 'oqe' ngogh",
  "block.minecraft.horn_coral_block": "pu' 'oqe' buq'ir",
  "block.minecraft.tube_coral": "'och 'oqe'",
  "block.minecraft.brain_coral": "qoghij 'oqe'",
  "block.minecraft.bubble_coral": "ba'suq 'oqe'",
  "block.minecraft.fire_coral": "qul 'oqe'",
  "block.minecraft.horn_coral": "pu' 'oqe'",
  "block.minecraft.dead_brain_coral": "heghpu'bogh qoghij 'oqe'",
  "block.minecraft.dead_bubble_coral": "heghpu'bogh ba'suq 'oqe'",
  "block.minecraft.dead_fire_coral": "heghpu'bogh qul 'oqe'",
  "block.minecraft.dead_horn_coral": "heghpu'bogh pu' 'oqe'",
  "block.minecraft.dead_tube_coral": "heghpu'bogh 'och 'oqe'",
  "block.minecraft.tube_coral_fan": "'och 'oqe' mijdang",
  "block.minecraft.brain_coral_fan": "qoghij 'oqe' mijdang",
  "block.minecraft.bubble_coral_fan": "ba'suq 'oqe' mijdang",
  "block.minecraft.fire_coral_fan": "qul 'oqe' mijdang",
  "block.minecraft.horn_coral_fan": "pu' 'oqe' mijdang",
  "block.minecraft.dead_tube_coral_fan": "heghpu'bogh 'och 'oqe' mijdang",
  "block.minecraft.dead_brain_coral_fan": "heghpu'bogh qoghij 'oqe' mijdang",
  "block.minecraft.dead_bubble_coral_fan": "heghpu'bogh ba'suq 'oqe' mijdang",
  "block.minecraft.dead_fire_coral_fan": "heghpu'bogh qul 'oqe' mijdang",
  "block.minecraft.dead_horn_coral_fan": "heghpu'bogh pu' 'oqe' mijdang",
  "block.minecraft.blue_ice": "chuch sud",
  "block.minecraft.conduit": "'och",
  "block.minecraft.polished_granite_stairs": "livri' hab letlh",
  "block.minecraft.smooth_red_sandstone_stairs": "habbogh do'ol nagh doq letlh",
  "block.minecraft.mossy_stone_brick_stairs": "‘ayivlas nagh ngoghmey letlh",
  "block.minecraft.polished_diorite_stairs": "habbogh nagh chis letlh",
  "block.minecraft.mossy_cobblestone_stairs": "'ayivlas nagh tlher letlh",
  "block.minecraft.end_stone_brick_stairs": "end nagh ngoghmey letlh",
  "block.minecraft.stone_stairs": "nagh letlh",
  "block.minecraft.smooth_sandstone_stairs": "do'ol nagh hab letlh",
  "block.minecraft.smooth_quartz_stairs": "chosom hab letlh",
  "block.minecraft.granite_stairs": "livri' letlh",
  "block.minecraft.andesite_stairs": "yuwey nagh letlh",
  "block.minecraft.red_nether_brick_stairs": "nether ngogh doq letlh",
  "block.minecraft.polished_andesite_stairs": "yuwey nagh hab letlh",
  "block.minecraft.diorite_stairs": "nagh chis letlh",
  "block.minecraft.polished_granite_slab": "livri' hab buq'ir bid",
  "block.minecraft.smooth_red_sandstone_slab": "habbogh do'ol nagh doq bid ngogh",
  "block.minecraft.mossy_stone_brick_slab": "‘ayivlas nagh ngoghmey buq'ir bid",
  "block.minecraft.polished_diorite_slab": "habbogh nagh chis buq'ir bid",
  "block.minecraft.mossy_cobblestone_slab": "'ayivlas nagh tlher buq'ir bid",
  "block.minecraft.end_stone_brick_slab": "end nagh ngoghmey buq'ir bid",
  "block.minecraft.smooth_sandstone_slab": "do'ol nagh hab buq'ir bid",
  "block.minecraft.smooth_quartz_slab": "chosom hab buq'ir bid",
  "block.minecraft.granite_slab": "livri' buq'ir bid",
  "block.minecraft.andesite_slab": "yuwey nagh buq'ir bid",
  "block.minecraft.red_nether_brick_slab": "nether ngogh doq buq'ir bid",
  "block.minecraft.polished_andesite_slab": "yuwey nagh hab buq'ir bid",
  "block.minecraft.diorite_slab": "nagh chis buq'ir bid",
  "block.minecraft.scaffolding": "chenmohmeh qal'aq",
  "block.minecraft.iron_door": "'usqan lojmit",
  "block.minecraft.oak_door": "'oq sor lojmit",
  "block.minecraft.spruce_door": "seprus sor lojmit",
  "block.minecraft.birch_door": "berich sor lojmit",
  "block.minecraft.jungle_door": "ngem yiq sor lojmit",
  "block.minecraft.acacia_door": "'aqey'sa sor lojmit",
  "block.minecraft.dark_oak_door": "sor hurgh lojmit",
  "block.minecraft.crimson_door": "ghe’tor sor doq lojmit",
  "block.minecraft.warped_door": "nether sor sud lojmit",
  "block.minecraft.repeater": "redstone hosmohwi'",
  "block.minecraft.comparator": "redstone juvwi'",
  "block.minecraft.structure_block": "qach buq'ir",
  "block.minecraft.jigsaw": "qay'mol buq'ir",
  "item.minecraft.turtle_helmet": "la'siv nagh dir□□nachdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.scute": "la'siv nagh dir 'ay'",
  "item.minecraft.iron_shovel": "'usqan ghevjur□□ghop wa'dichdaq tu'lu'di':□+3.5 hiv qih□-3 hiv do",
  "item.minecraft.iron_pickaxe": "'usqan tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+3 hiv qih□-2.8 hiv do",
  "item.minecraft.iron_axe": "'usqan 'obmaq□□ghop wa'dichdaq tu'lu'di':□+8 hiv qih□-3.1 hiv do",
  "item.minecraft.flint_and_steel": "qul chenmohwi'",
  "item.minecraft.apple": "'epil nah",
  "item.minecraft.bow": "hurwi'",
  "item.minecraft.arrow": "naqjejhom",
  "item.minecraft.coal": "ghav nin",
  "item.minecraft.charcoal": "sor ghav nin",
  "item.minecraft.diamond": "ghav qut",
  "item.minecraft.iron_ingot": "'usqan ngogh",
  "item.minecraft.gold_ingot": "qol'om ngogh",
  "item.minecraft.netherite_ingot": "netherite ngogh",
  "item.minecraft.netherite_scrap": "netherite bas 'ay'",
  "item.minecraft.iron_sword": "'usqan yan□□ghop wa'dichdaq tu'lu'di':□+5 hiv qih□-2.4 hiv do",
  "item.minecraft.wooden_sword": "sor hap yan□□ghop wa'dichdaq tu'lu'di':□+3 hiv qih□-2.4 hiv do",
  "item.minecraft.wooden_shovel": "sor hap ghevjur□□ghop wa'dichdaq tu'lu'di':□+1.5 hiv qih□-3 hiv do",
  "item.minecraft.wooden_pickaxe": "sor hap tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+1 hiv qih□-2.8 hiv do",
  "item.minecraft.wooden_axe": "sor hap 'obmaq□□ghop wa'dichdaq tu'lu'di':□+6 hiv qih□-3.2 hiv do",
  "item.minecraft.stone_sword": "nagh yan□□ghop wa'dichdaq tu'lu'di':□+4 hiv qih□-2.4 hiv do",
  "item.minecraft.stone_shovel": "nagh ghevjur□□ghop wa'dichdaq tu'lu'di':□+2.5 hiv qih□-3 hiv do",
  "item.minecraft.stone_pickaxe": "nagh tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+2 hiv qih□-2.8 hiv do",
  "item.minecraft.stone_axe": "nagh 'obmaq□□ghop wa'dichdaq tu'lu'di':□+8 hiv qih□-3.2 hiv do",
  "item.minecraft.diamond_sword": "ghav qut yan□□ghop wa'dichdaq tu'lu'di':□+6 hiv qih□-2.4 hiv do",
  "item.minecraft.diamond_shovel": "ghav qut ghevjur□□ghop wa'dichdaq tu'lu'di':□+4.5 hiv qih□-3 hiv do",
  "item.minecraft.diamond_pickaxe": "ghav qut tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+4 hiv qih□-2.8 hiv do",
  "item.minecraft.diamond_axe": "ghav qut 'obmaq□□ghop wa'dichdaq tu'lu'di':□+8 hiv qih□-3 hiv do",
  "item.minecraft.stick": "naq",
  "item.minecraft.bowl": "duq",
  "item.minecraft.mushroom_stew": "yav 'atlhqam tlhiq",
  "item.minecraft.golden_sword": "qol'om yan□□ghop wa'dichdaq tu'lu'di':□+3 hiv qih□-2.4 hiv do",
  "item.minecraft.golden_shovel": "qol'om ghevjur□□ghop wa'dichdaq tu'lu'di':□+1.5 hiv qih□-3 hiv do",
  "item.minecraft.golden_pickaxe": "qol'om tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+1 hiv qih□-2.8 hiv do",
  "item.minecraft.golden_axe": "qol'om 'obmaq□□ghop wa'dichdaq tu'lu'di':□+6 hiv qih□-3 hiv do",
  "item.minecraft.netherite_sword": "netherite yan□□ghop wa'dichdaq tu'lu'di':□+7 hiv qih□-2.4 hiv do",
  "item.minecraft.netherite_shovel": "netherite ghevjur□□ghop wa'dichdaq tu'lu'di':□+5.5 hiv qih□-3 hiv do",
  "item.minecraft.netherite_pickaxe": "netherite tlhilwi' jan□□ghop wa'dichdaq tu'lu'di':□+5 hiv qih□-2.8 hiv do",
  "item.minecraft.netherite_axe": "netherite 'obmaq□□ghop wa'dichdaq tu'lu'di':□+9 hiv qih□-3 hiv do",
  "item.minecraft.string": "sirgh",
  "item.minecraft.feather": "bo",
  "item.minecraft.gunpowder": "ngat",
  "item.minecraft.wooden_hoe": "sor hap wijwi' jan□□ghop wa'dichdaq tu'lu'di':□-3 hiv do",
  "item.minecraft.stone_hoe": "nagh wijwi' jan□□ghop wa'dichdaq tu'lu'di':□-2 hiv do",
  "item.minecraft.iron_hoe": "'usqan wijwi' jan□□ghop wa'dichdaq tu'lu'di':□-1 hiv do",
  "item.minecraft.diamond_hoe": "ghav qut wijwi' jan□□ghop wa'dichdaq tu'lu'di':",
  "item.minecraft.golden_hoe": "qol'om wijwi' jan□□ghop wa'dichdaq tu'lu'di':□-3 hiv do",
  "item.minecraft.netherite_hoe": "netherite wijwi' jan□□ghop wa'dichdaq tu'lu'di':",
  "item.minecraft.wheat_seeds": "tir ras'is",
  "item.minecraft.wheat": "tir",
  "item.minecraft.bread": "tir ngogh",
  "item.minecraft.leather_helmet": "qo'rin dir miv□□nachdaq tu'lu'di':□+1 may' sut",
  "item.minecraft.leather_chestplate": "qo'rin dir wep□□rodaq tu'lu'di':□+3 may' sut",
  "item.minecraft.leather_leggings": "qo'rin dir yopwah□□'usdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.leather_boots": "qo'rin dir das□□qamdaq tu'lu'di':□+1 may' sut",
  "item.minecraft.chainmail_helmet": "mir miv□□nachdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.chainmail_chestplate": "mir wep□□rodaq tu'lu'di':□+5 may' sut",
  "item.minecraft.chainmail_leggings": "mir yopwah□□'usdaq tu'lu'di':□+4 may' sut",
  "item.minecraft.chainmail_boots": "mir das□□qamdaq tu'lu'di':□+1 may' sut",
  "item.minecraft.iron_helmet": "'usqan miv□□nachdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.iron_chestplate": "'usqan wep□□rodaq tu'lu'di':□+6 may' sut",
  "item.minecraft.iron_leggings": "'usqan yopwah□□'usdaq tu'lu'di':□+5 may' sut",
  "item.minecraft.iron_boots": "'usqan das□□qamdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.diamond_helmet": "ghav qut miv□□nachdaq tu'lu'di':□+3 may' sut□+2 may' sut rotlhghach",
  "item.minecraft.diamond_chestplate": "ghav qut wep□□rodaq tu'lu'di':□+8 may' sut□+2 may' sut rotlhghach",
  "item.minecraft.diamond_leggings": "ghav qut yopwah□□'usdaq tu'lu'di':□+6 may' sut□+2 may' sut rotlhghach",
  "item.minecraft.diamond_boots": "ghav qut das□□qamdaq tu'lu'di':□+3 may' sut□+2 may' sut rotlhghach",
  "item.minecraft.golden_helmet": "qol'om miv□□nachdaq tu'lu'di':□+2 may' sut",
  "item.minecraft.golden_chestplate": "qol'om wep□□rodaq tu'lu'di':□+5 may' sut",
  "item.minecraft.golden_leggings": "qol'om yopwah□□'usdaq tu'lu'di':□+3 may' sut",
  "item.minecraft.golden_boots": "qol'om dasmey□□qamdaq tu'lu'di':□+1 may' sut",
  "item.minecraft.netherite_helmet": "ghe'tor bas miv□□nachdaq tu'lu'di':□+3 may' sut□+3 may' sut rotlhghach□+1 resistance knock witi'nismo'",
  "item.minecraft.netherite_chestplate": "netherite wep□□rodaq tu'lu'di':□+8 may' sut□+3 may' sut rotlhghach□+1 resistance knock witi'nismo'",
  "item.minecraft.netherite_leggings": "netherite yopwah□□'usdaq tu'lu'di':□+6 may' sut□+3 may' sut rotlhghach□+1 resistance knock witi'nismo'",
  "item.minecraft.netherite_boots": "ghe'tor bas das□□qamdaq tu'lu'di':□+3 may' sut□+3 may' sut rotlhghach□+1 resistance knock witi'nismo'",
  "item.minecraft.flint": "qijbogh 'ej letbogh nagh",
  "item.minecraft.porkchop": "targh ghab vutbe'lu'bogh",
  "item.minecraft.cooked_porkchop": "targh ghab vut'lu'ta'bogh",
  "item.minecraft.painting": "nagh beq",
  "item.minecraft.golden_apple": "qol'om 'epil nah",
  "item.minecraft.enchanted_golden_apple": "qol'om ep'il nah reslu'pu'bogh",
  "block.minecraft.oak_sign": "'oq sor qin 'echlet",
  "block.minecraft.spruce_sign": "seprus sor qin 'echlet",
  "block.minecraft.birch_sign": "berich sor qin 'echlet",
  "block.minecraft.jungle_sign": "ngem yiq sor qin 'echlet",
  "block.minecraft.acacia_sign": "'aqey'sa sor qin 'echlet",
  "block.minecraft.dark_oak_sign": "'oq hurgh sor qin 'echlet",
  "block.minecraft.crimson_sign": "ghe’tor sor doq qin 'echlet",
  "block.minecraft.warped_sign": "nether sor sud qin 'echlet",
  "item.minecraft.bucket": "haysin",
  "item.minecraft.water_bucket": "biq haysin",
  "item.minecraft.lava_bucket": "vahbo' haysin",
  "item.minecraft.minecart": "tlhilhal duj",
  "item.minecraft.saddle": "lighmeh qus",
  "item.minecraft.redstone": "redstone say'qis",
  "item.minecraft.snowball": "chal chuch moq",
  "item.minecraft.oak_boat": "'oq sor biq duj",
  "item.minecraft.leather": "qo'rin dir",
  "item.minecraft.milk_bucket": "nim haysin",
  "item.minecraft.pufferfish_bucket": "lunbogh ghoti' haysin",
  "item.minecraft.salmon_bucket": "biqtiq ghoti' haysin",
  "item.minecraft.cod_bucket": "qad ghoti' haysin",
  "item.minecraft.tropical_fish_bucket": "biq ghun ghoti' haysin",
  "item.minecraft.brick": "ngogh",
  "item.minecraft.clay_ball": "dabqi' 'ay'",
  "block.minecraft.dried_kelp_block": "monqiv qad ngogh",
  "item.minecraft.paper": "nav",
  "item.minecraft.book": "paq",
  "item.minecraft.slime_ball": "huh moq",
  "item.minecraft.chest_minecart": "derliq ghajbogh tlhilhal duj",
  "item.minecraft.furnace_minecart": "nagh tetwi' ghajbogh tlhilhal duj",
  "item.minecraft.egg": "qim",
  "item.minecraft.compass": "sinan",
  "item.minecraft.fishing_rod": "ghoti' jonmeh naq",
  "item.minecraft.clock": "tlhaq",
  "item.minecraft.glowstone_dust": "wewbogh nagh say'qis",
  "item.minecraft.cod": "qad ghoti' tlhol",
  "item.minecraft.salmon": "samin ghoti' tlhol",
  "item.minecraft.tropical_fish": "biq ghun ghoti'",
  "item.minecraft.pufferfish": "lunbogh ghoti'",
  "item.minecraft.cooked_cod": "qad ghoti' vutlu'pu'bogh",
  "item.minecraft.cooked_salmon": "samin ghoti' vutlu'pu'bogh",
  "item.minecraft.ink_sac": "qijbogh ritlh",
  "item.minecraft.red_dye": "ritlh doqqu'",
  "item.minecraft.green_dye": "ritlh sudqu’",
  "item.minecraft.cocoa_beans": "yuch qurgh",
  "item.minecraft.lapis_lazuli": "tlhil sud",
  "item.minecraft.purple_dye": "doqbogh 'ej sudbogh ritlh",
  "item.minecraft.cyan_dye": "sudbogh ’ej wovqu’bogh ritlh",
  "item.minecraft.light_gray_dye": "qijbogh 'ej wovqu'bogh ritlh",
  "item.minecraft.gray_dye": "qijbogh 'ej wovbogh ritlh",
  "item.minecraft.pink_dye": "doqqu'bogh 'ej wovbogh ritlh",
  "item.minecraft.lime_dye": "sudbogh 'ej wovbe'bogh ritlh",
  "item.minecraft.yellow_dye": "sudbogh ‘ej wovbogh ritlh",
  "item.minecraft.light_blue_dye": "sudbogh 'ej wovbogh ritlh",
  "item.minecraft.magenta_dye": "doqqu'bogh 'ej sudbogh ritlh",
  "item.minecraft.orange_dye": "doqbogh ritlh",
  "item.minecraft.bone_meal": "hom say'qis",
  "item.minecraft.blue_dye": "sudbogh ‘ej hurghbogh ritlh",
  "item.minecraft.brown_dye": "doqbogh ‘ej wovbe’bogh ritlh",
  "item.minecraft.black_dye": "ritlh qij",
  "item.minecraft.white_dye": "ritlh chis",
  "item.minecraft.bone": "hom",
  "item.minecraft.sugar": "su'ghar",
  "block.minecraft.cake": "chab'a'",
  "block.minecraft.white_bed": "qongdaq chis",
  "block.minecraft.orange_bed": "doqbogh ‘ej wovbogh qongdaq",
  "block.minecraft.magenta_bed": "doqqu’bogh ‘ej sudbogh qongdaq",
  "block.minecraft.light_blue_bed": "sudbogh ‘ej wovbogh qongdaq",
  "block.minecraft.yellow_bed": "sudbogh ‘ej wovbogh qongdaq",
  "block.minecraft.lime_bed": "sudqu'bogh 'ej wovbogh qongdaq",
  "block.minecraft.pink_bed": "doqqu’bogh ‘ej wovbogh qongdaq",
  "block.minecraft.gray_bed": "qijbogh 'ej wovbogh qongdaq",
  "block.minecraft.light_gray_bed": "qijbogh 'ej wovqu'bogh qongdaq",
  "block.minecraft.cyan_bed": "sudbogh 'ej wovqu'bogh qongdaq",
  "block.minecraft.purple_bed": "doqbogh 'ej sudbogh qongdaq",
  "block.minecraft.blue_bed": "sudbogh ‘ej hurghbogh qongdaq",
  "block.minecraft.brown_bed": "doqbogh ‘ej wovbe’bogh qongdaq",
  "block.minecraft.green_bed": "qongdaq sudqu’",
  "block.minecraft.red_bed": "qongdaq doqqu'",
  "block.minecraft.black_bed": "qongdaq qij",
  "item.minecraft.cookie": "su'ghar chabhom",
  "item.minecraft.filled_map": "pu'jin□#0",
  "item.minecraft.shears": "cha''etlh pe'wi''a'",
  "item.minecraft.melon_slice": "qaq nah baylad",
  "item.minecraft.dried_kelp": "monqiv qad",
  "item.minecraft.pumpkin_seeds": "'aquta' ras'ismey",
  "item.minecraft.melon_seeds": "qaq nah ras'is",
  "item.minecraft.beef": "tangqa' ghab vutbe'lu'bogh",
  "item.minecraft.cooked_beef": "tangqa' ghab vutlu'ta'bogh",
  "item.minecraft.chicken": "'usgheb ghab vutbe'lu'bogh",
  "item.minecraft.cooked_chicken": "'usgheb ghab vutlu'ta'bogh",
  "item.minecraft.rotten_flesh": "ha'dibah non",
  "item.minecraft.ender_pearl": "ender moq",
  "item.minecraft.blaze_rod": "qul naq",
  "item.minecraft.ghast_tear": "qa''a' min 'onros",
  "item.minecraft.gold_nugget": "qol'om ngoghhom",
  "item.minecraft.nether_wart": "nether yav 'atlhqam",
  "item.minecraft.potion": "chenmohlahbe'bogh 'idnar tas□pagh",
  "item.minecraft.glass_bottle": "'al'on bal",
  "item.minecraft.spider_eye": "vodchuch min",
  "item.minecraft.fermented_spider_eye": "ghew nas min roghmohlu'",
  "item.minecraft.blaze_powder": "qul yagh say'qis",
  "item.minecraft.magma_cream": "vahbo' tlhagh",
  "block.minecraft.brewing_stand": "tas vutmeh qal'aq",
  "block.minecraft.cauldron": "bargh'a'",
  "item.minecraft.ender_eye": "ender min",
  "item.minecraft.glistering_melon_slice": "ghonbogh qaq nah baylad",
  "item.minecraft.bat_spawn_egg": "valqe' boghmohbogh qim'e'",
  "item.minecraft.bee_spawn_egg": "'aw'bogh ghew boghmohbogh qim'e'",
  "item.minecraft.blaze_spawn_egg": "qul tlhapragh boghmohbogh qim'e'",
  "item.minecraft.cat_spawn_egg": "vighro' boghmohbogh qim'e'",
  "item.minecraft.cave_spider_spawn_egg": "dis vodchuch boghmohbogh qim'e'",
  "item.minecraft.chicken_spawn_egg": "'usgheb boghmohbogh qim'e'",
  "item.minecraft.cod_spawn_egg": "qad ghoti' boghmohbogh qim'e'",
  "item.minecraft.cow_spawn_egg": "tangqa' boghmohbogh qim'e'",
  "item.minecraft.creeper_spawn_egg": "creeper boghmohbogh qim'e'",
  "item.minecraft.dolphin_spawn_egg": "solbis boghmohbogh qim'e'",
  "item.minecraft.donkey_spawn_egg": "jachbogh sargh boghmohbogh qim'e'",
  "item.minecraft.drowned_spawn_egg": "biqdaq viqbogh 'ej yinbogh lom boghmohbogh qim'e'",
  "item.minecraft.elder_guardian_spawn_egg": "'avwi' qan boghmohbogh qim'e'",
  "item.minecraft.enderman_spawn_egg": "enderman boghmohbogh qim'e'",
  "item.minecraft.endermite_spawn_egg": "endermite boghmohbogh qim'e'",
  "item.minecraft.evoker_spawn_egg": "reswi' boghmohbogh qim'e'",
  "item.minecraft.fox_spawn_egg": "qeshos boghmohbogh qim'e'",
  "item.minecraft.ghast_spawn_egg": "qa''a' boghmohbogh qim'e'",
  "item.minecraft.guardian_spawn_egg": "'avwi' boghmohbogh qim'e'",
  "item.minecraft.hoglin_spawn_egg": "hoglin boghmohbogh qim'e'",
  "item.minecraft.horse_spawn_egg": "sargh boghmohbogh qim'e'",
  "item.minecraft.husk_spawn_egg": "yub boghmohbogh qim'e'",
  "item.minecraft.llama_spawn_egg": "'imtiy boghmohbogh qim'e'",
  "item.minecraft.magma_cube_spawn_egg": "vahbo' buq'ir boghmohbogh qim'e'",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom boghmohbogh qim'e'",
  "item.minecraft.mule_spawn_egg": "qu'vatlh boghmohbogh qim'e'",
  "item.minecraft.ocelot_spawn_egg": "vighro''a' boghmohbogh qim'e'",
  "item.minecraft.panda_spawn_egg": "bambu' mil'od boghmohbogh qim'e'",
  "item.minecraft.parrot_spawn_egg": "vilinhod boghmohbogh qim'e'",
  "item.minecraft.phantom_spawn_egg": "ram toq boghmohbogh qim'e'",
  "item.minecraft.pig_spawn_egg": "suy' boghmohbogh qim'e'",
  "item.minecraft.piglin_spawn_egg": "piglin boghmohbogh qim'e'",
  "item.minecraft.pillager_spawn_egg": "wehwi' boghmohbogh qim'e'",
  "item.minecraft.polar_bear_spawn_egg": "chuch mil'od boghmohbogh qim'e'",
  "item.minecraft.pufferfish_spawn_egg": "lunbogh ghoti' boghmohbogh qim'e'",
  "item.minecraft.rabbit_spawn_egg": "ches boghmohbogh qim'e'",
  "item.minecraft.ravager_spawn_egg": "ha'dibah qaw'bogh boghmohbogh qim'e'",
  "item.minecraft.salmon_spawn_egg": "samin ghoti' boghmohbogh qim'e'",
  "item.minecraft.sheep_spawn_egg": "di'raq boghmohbogh qim'e'",
  "item.minecraft.shulker_spawn_egg": "shulker boghmohbogh qim'e'",
  "item.minecraft.silverfish_spawn_egg": "sirliy ghew boghmohbogh qim'e'",
  "item.minecraft.skeleton_spawn_egg": "nobmed boghmohbogh qim'e'",
  "item.minecraft.skeleton_horse_spawn_egg": "nobmed sargh boghmohbogh qim'e'",
  "item.minecraft.slime_spawn_egg": "huh boghmohbogh qim'e'",
  "item.minecraft.spider_spawn_egg": "vodchuch boghmohbogh qim'e'",
  "item.minecraft.squid_spawn_egg": "cheyis boghmohbogh qim'e'",
  "item.minecraft.stray_spawn_egg": "nobmed tad boghmohbogh qim'e'",
  "item.minecraft.strider_spawn_egg": "yitwi' boghmohbogh qim'e'",
  "item.minecraft.trader_llama_spawn_egg": "suy 'imtiy boghmohbogh qim'e'",
  "item.minecraft.tropical_fish_spawn_egg": "biq ghun ghoti' boghmohbogh qim'e'",
  "item.minecraft.turtle_spawn_egg": "la'siv boghmohbogh qim'e'",
  "item.minecraft.vex_spawn_egg": "nuqwi' boghmohbogh qim'e'",
  "item.minecraft.villager_spawn_egg": "venghom ghot boghmohbogh qim",
  "item.minecraft.vindicator_spawn_egg": "'obmaq ghajbogh wehwi' boghmohbogh qim",
  "item.minecraft.wandering_trader_spawn_egg": "suy lengbogh boghmohbogh qim",
  "item.minecraft.witch_spawn_egg": "'idnar pin'a' boghmohbogh qim",
  "item.minecraft.wither_skeleton_spawn_egg": "wither nobmed boghmohbogh qim'e'",
  "item.minecraft.wolf_spawn_egg": "ngavyaw' boghmohbogh qim'e'",
  "item.minecraft.zoglin_spawn_egg": "zoglin boghmohbogh qim'e'",
  "item.minecraft.zombie_spawn_egg": "yinbogh lom boghmohbogh qim'e'",
  "item.minecraft.zombie_horse_spawn_egg": "yinbogh lom sargh boghmohbogh qim",
  "item.minecraft.zombie_villager_spawn_egg": "yinbogh lom venghom ghot boghmohbogh qim",
  "item.minecraft.zombified_piglin_spawn_egg": "yinbogh piglin lom boghmohbogh qim'e'",
  "item.minecraft.experience_bottle": "resmeh bal",
  "item.minecraft.fire_charge": "qul moq",
  "item.minecraft.writable_book": "paq ghitlhwi' bo je",
  "item.minecraft.written_book": "ghitlhta' paq",
  "item.minecraft.emerald": "patmor",
  "item.minecraft.item_frame": "doch bey'",
  "block.minecraft.flower_pot": "chor bargh",
  "item.minecraft.carrot": "qe'rot 'oqqar",
  "item.minecraft.potato": "patat 'oqqar",
  "item.minecraft.baked_potato": "patat 'oqqar meqlu'pu'bogh",
  "item.minecraft.poisonous_potato": "patat 'oqqar suq",
  "item.minecraft.map": "pu'jin chim",
  "item.minecraft.golden_carrot": "qol'om qe'rot 'oqqar",
  "block.minecraft.skeleton_skull": "nobmed dughri'",
  "block.minecraft.wither_skeleton_skull": "wither nobmed dughri'",
  "block.minecraft.player_head": "qujwi' nach",
  "block.minecraft.zombie_head": "yinbogh lom nach",
  "block.minecraft.creeper_head": "creeper nach",
  "block.minecraft.dragon_head": "lung'a' nach",
  "item.minecraft.carrot_on_a_stick": "qe'rot 'oqqar naq",
  "item.minecraft.warped_fungus_on_a_stick": "'atlhqam sud naq",
  "item.minecraft.nether_star": "ghe'tor hov",
  "item.minecraft.pumpkin_pie": "'aquta' nah chab",
  "item.minecraft.firework_rocket": "lop jorwi'",
  "item.minecraft.firework_star": "lop jorwi' hov",
  "item.minecraft.enchanted_book": "tlheh paq",
  "item.minecraft.nether_brick": "nether ngogh",
  "item.minecraft.quartz": "nether chosom",
  "item.minecraft.tnt_minecart": "jorwi' tlhilhal duj",
  "item.minecraft.hopper_minecart": "tomter ghajbogh tlhilhal duj",
  "item.minecraft.prismarine_shard": "prismarine 'ay'",
  "item.minecraft.prismarine_crystals": "prismarine qutmey",
  "item.minecraft.rabbit": "ches tlhol",
  "item.minecraft.cooked_rabbit": "ches vut'lu'pu'bogh",
  "item.minecraft.rabbit_stew": "ches chatlh",
  "item.minecraft.rabbit_foot": "ches qam",
  "item.minecraft.rabbit_hide": "ches dir",
  "item.minecraft.armor_stand": "may' sut qal'aq",
  "item.minecraft.iron_horse_armor": "'usqan sargh may'sut",
  "item.minecraft.golden_horse_armor": "qol'om sargh may' sut",
  "item.minecraft.diamond_horse_armor": "ghav qut sargh may'sut",
  "item.minecraft.leather_horse_armor": "qo'rin dir sargh may'sut",
  "item.minecraft.lead": "devbogh tlhegh",
  "item.minecraft.name_tag": "pong per",
  "item.minecraft.command_block_minecart": "ra'wi' buq'ir tlhilhal duj",
  "item.minecraft.mutton": "di'raq ghab tlhol",
  "item.minecraft.cooked_mutton": "di'raq ghab vutlu'ta'bogh",
  "block.minecraft.white_banner": "joqwi' chis",
  "block.minecraft.orange_banner": "doqbogh ‘ej wovbogh joqwi'",
  "block.minecraft.magenta_banner": "doqqu’bogh ‘ej sudbogh joqwi'",
  "block.minecraft.light_blue_banner": "sudbogh ‘ej wovbogh joqwi'",
  "block.minecraft.yellow_banner": "sudbogh ‘ej wovbogh joqwi'",
  "block.minecraft.lime_banner": "sudqu’bogh ‘ej wovbogh joqwi'",
  "block.minecraft.pink_banner": "doqqu’bogh ‘ej wovbogh joqwi'",
  "block.minecraft.gray_banner": "qijbogh 'ej wovbogh joqwi'",
  "block.minecraft.light_gray_banner": "qijbogh ‘ej wovqu’bogh joqwi'",
  "block.minecraft.cyan_banner": "sudbogh ’ej wovqu’bogh joqwi'",
  "block.minecraft.purple_banner": "doqbogh 'ej sudbogh joqwi'",
  "block.minecraft.blue_banner": "sudbogh ‘ej hurghbogh joqwi'",
  "block.minecraft.brown_banner": "doqbogh ‘ej wovbe’bogh joqwi'",
  "block.minecraft.green_banner": "joqwi' sudqu’",
  "block.minecraft.red_banner": "joqwi' doqqu'",
  "block.minecraft.black_banner": "joqwi' qij",
  "item.minecraft.end_crystal": "end qut",
  "item.minecraft.chorus_fruit": "bomwi' ghom nah",
  "item.minecraft.popped_chorus_fruit": "bomwi' ghom nah ghorlu'pu'bogh",
  "item.minecraft.beetroot": "'oqqar doqqu'",
  "item.minecraft.beetroot_seeds": "'oqqar doqqu' ras'is",
  "item.minecraft.beetroot_soup": "'oqqar doqqu' chatlh",
  "item.minecraft.dragon_breath": "lung'a' tlhuh",
  "item.minecraft.splash_potion": "'idnar tas ghitbogh chenmohlah'be'□pagh",
  "item.minecraft.spectral_arrow": "le' bach",
  "item.minecraft.tipped_arrow": "chenmohlahbe'bogh 'idnar naqjejhom□pagh",
  "item.minecraft.lingering_potion": "chenmohlahbe'bogh 'ej ratlhbogh 'idnar tas□pagh",
  "item.minecraft.shield": "yod",
  "item.minecraft.elytra": "telmeyqoq",
  "item.minecraft.spruce_boat": "seprus sor biq duj",
  "item.minecraft.birch_boat": "berich sor biq duj",
  "item.minecraft.jungle_boat": "ngem yiq sor biq duj",
  "item.minecraft.acacia_boat": "'aqey'sa sor biq duj",
  "item.minecraft.dark_oak_boat": "'oq hurgh sor biq duj",
  "item.minecraft.totem_of_undying": "jubmohmeh hewhom",
  "item.minecraft.shulker_shell": "ghachwi' nagh dir",
  "item.minecraft.iron_nugget": "'usqan ngoghhom",
  "item.minecraft.knowledge_book": "sov paq",
  "item.minecraft.debug_stick": "ti'meh naq",
  "item.minecraft.music_disc_13": "bom jengva'□c418 - 13",
  "item.minecraft.music_disc_cat": "bom jengva'□c418 - cat",
  "item.minecraft.music_disc_blocks": "bom jengva'□c418 - blocks",
  "item.minecraft.music_disc_chirp": "bom jengva'□c418 - chirp",
  "item.minecraft.music_disc_far": "bom jengva'□c418 - far",
  "item.minecraft.music_disc_mall": "bom jengva'□c418 - mall",
  "item.minecraft.music_disc_mellohi": "bom jengva'□c418 - mellohi",
  "item.minecraft.music_disc_stal": "bom jengva'□c418 - stal",
  "item.minecraft.music_disc_strad": "bom jengva'□c418 - strad",
  "item.minecraft.music_disc_ward": "bom jengva'□c418 - ward",
  "item.minecraft.music_disc_11": "bom jengva'□c418 - 11",
  "item.minecraft.music_disc_wait": "bom jengva'□c418 - wait",
  "item.minecraft.music_disc_pigstep": "bom jengva'□lena raine - pigstep",
  "item.minecraft.trident": "chonnaq□□ghop wa'dichdaq tu'lu'di':□+8 hiv qih□-2.9 hiv do",
  "item.minecraft.phantom_membrane": "ram toq yelmo’",
  "item.minecraft.nautilus_shell": "qatvoh nagh dir",
  "item.minecraft.heart_of_the_sea": "biq'a' tiq",
  "item.minecraft.crossbow": "jo' hurwi'",
  "item.minecraft.suspicious_stew": "tlhiq pih",
  "block.minecraft.loom": "niqmeh qal'aq",
  "item.minecraft.flower_banner_pattern": "joqwi' hasreh□'insong degh",
  "item.minecraft.creeper_banner_pattern": "joqwi' hasreh□creeper degh",
  "item.minecraft.skull_banner_pattern": "joqwi' hasreh□dughri' degh",
  "item.minecraft.mojang_banner_pattern": "joqwi' hasreh□doch",
  "item.minecraft.globe_banner_pattern": "joqwi' hasreh□qo'",
  "item.minecraft.piglin_banner_pattern": "joqwi' hasreh□ghich",
  "block.minecraft.composter": "nonmohwi' 'ib",
  "block.minecraft.barrel": "qegh",
  "block.minecraft.smoker": "tlhich vincha'",
  "block.minecraft.blast_furnace": "vincha' tujqu'",
  "block.minecraft.cartography_table": "pu'jin ras",
  "block.minecraft.fletching_table": "naqjejhom ras",
  "block.minecraft.grindstone": "jejmohmeh nagh",
  "block.minecraft.lectern": "paq ras",
  "block.minecraft.smithing_table": "mitlhmeh ras",
  "block.minecraft.stonecutter": "nagh pe'wi'",
  "block.minecraft.bell": "'in",
  "block.minecraft.lantern": "wovmohwi'",
  "block.minecraft.soul_lantern": "qa' wovmohwi'",
  "item.minecraft.sweet_berries": "nah doqqu'",
  "block.minecraft.campfire": "raq qul",
  "block.minecraft.soul_campfire": "qa' raq qul",
  "block.minecraft.shroomlight": "'atlhqam wovmohwi'",
  "item.minecraft.honeycomb": "dayqir sir'o'",
  "block.minecraft.bee_nest": "'aw'bogh ghew yanwo'",
  "block.minecraft.beehive": "'aw'bogh ghew juh",
  "item.minecraft.honey_bottle": "dayqir bal",
  "block.minecraft.honey_block": "dayqir buq'ir",
  "block.minecraft.honeycomb_block": "dayqir sir'o' buq'ir",
  "block.minecraft.lodestone": "peqnagh",
  "block.minecraft.netherite_block": "netherite buq'ir",
  "block.minecraft.ancient_debris": "di tiq",
  "block.minecraft.target": "dos",
  "block.minecraft.crying_obsidian": "saqbogh 'al'on nagh",
  "block.minecraft.blackstone": "nagh qij",
  "block.minecraft.blackstone_slab": "nagh qij buq'ir bid",
  "block.minecraft.blackstone_stairs": "nagh qij letlh",
  "block.minecraft.gilded_blackstone": "qol'om nagh qij",
  "block.minecraft.polished_blackstone": "habbogh nagh qij",
  "block.minecraft.polished_blackstone_slab": "habbogh nagh qij buq'ir bid",
  "block.minecraft.polished_blackstone_stairs": "habbogh nagh qij letlh",
  "block.minecraft.chiseled_polished_blackstone": "habbogh nagh qij quhlu'bogh",
  "block.minecraft.polished_blackstone_bricks": "habbogh nagh qij ngoghmey",
  "block.minecraft.polished_blackstone_brick_slab": "habbogh nagh qij ngoghmey buq'ir bid",
  "block.minecraft.polished_blackstone_brick_stairs": "habbogh nagh qij ngoghmey letlh",
  "block.minecraft.cracked_polished_blackstone_bricks": "habbogh nagh qij ngoghmey qihlu'bogh",
  "block.minecraft.respawn_anchor": "boghqa'meh jan",
}
export const tlh_aa = items; 
